.root {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: var(--space-2);
  min-inline-size: 0;
  margin: 0;
  padding: 0;
  border: none;
}

.root[data-disabled] {
  cursor: not-allowed;
}

.legend,
.description {
  flex-basis: 100%;
}

.legend {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.description {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}
